module.exports = __webpack_public_path__ + "img/box.1f39f7fb.svg";